var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownPinkUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72898 3.35402L2.36898 10.72C2.24026 10.8496 2.08719 10.9524 1.91857 11.0226C1.74995 11.0927 1.56912 11.1288 1.38649 11.1288C1.20385 11.1288 1.02302 11.0927 0.854403 11.0226C0.685784 10.9524 0.53271 10.8496 0.403986 10.72C0.14445 10.4579 -0.00114059 10.1039 -0.00114059 9.73502C-0.00114059 9.36614 0.14445 9.01216 0.403986 8.75002L8.74398 0.405022C8.99693 0.1526 9.33749 0.00746167 9.69476 -0.000175476C10.052 -0.00781262 10.3985 0.12264 10.662 0.364021L19.062 8.74402C19.3232 9.0046 19.4702 9.35828 19.4707 9.72725C19.4712 10.0962 19.3251 10.4503 19.0645 10.7115C18.8039 10.9728 18.4502 11.1198 18.0813 11.1203C17.7123 11.1207 17.3582 10.9746 17.097 10.714L9.72898 3.35402Z",
    fill: "#E8339E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.464,
    height: 11.129,
    fill: "white",
    transform: "translate(19.464 11.129) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPinkUp);
export default __webpack_public_path__ + "static/media/arrow_down_pink_up.a0604721cd167761a0f0e5ae99200dbd.svg";
export { ForwardRef as ReactComponent };